import { listingCategoriesFacadesMock, titreDescriptionMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(true, false), listingCategoriesFacadesMock];

export const categoriesFacadesMock: SlugPage = {
  ...pageBase({
    title: 'Façades',
    type: 'facades',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
